// frontend/src/components/LandingPage.js
import React from 'react';
import { Link } from 'react-router-dom';

import banner from '../assets/banner.jpg';

const LandingPage = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-blue-100 flex flex-col">
      {/* Header */}
      <header
        className="text-white shadow-lg bg-cover bg-center"
        style={{ backgroundImage: `url(${banner})` }}
      >
        <div className="max-w-7xl mx-auto px-4 py-6">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-3">
              <img
                src="/logo.png"
                alt="FIH Logo"
                className="h-12 w-auto"
                onError={(e) => { e.target.style.display = 'none' }}
              />
              <div>
                <h1 className="text-2xl font-bold text-white">FIH Photo Upload Portal</h1>
                <p className="text-sm text-indigo-100">Official Team Photo Management System</p>
              </div>
            </div>
            <Link
              to="/admin/events"
              className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
            >
              Admin Login
            </Link>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="flex-grow flex items-center justify-center px-4 py-12">
        <div className="text-center max-w-3xl mx-auto">
          <h2 className="text-4xl font-bold text-gray-900 mb-6">
            Welcome to the FIH Photo Upload Portal
          </h2>
          <p className="text-xl text-gray-600 mb-8">
            This secure platform allows team managers to upload and manage player photos for upcoming FIH tournaments.
          </p>

          <div className="bg-white p-8 rounded-xl shadow-lg border border-blue-100">
            <h3 className="text-lg font-semibold text-gray-800 mb-2">How to Access</h3>
            <p className="text-gray-600 mb-4">
              Team Managers must use the unique secure link provided by the tournament organizers to access their team's upload area.
            </p>
            <div className="inline-block bg-blue-50 text-blue-800 px-4 py-2 rounded-lg text-sm border border-blue-200">
              Please check your email for your team's access link.
            </div>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="bg-white border-t border-gray-200 py-6 text-center text-sm text-gray-500">
        <p>© 2025 International Hockey Federation (FIH). All rights reserved.</p>
        <p className="mt-1">
          For technical support, contact: support@fih.hockey
        </p>
      </footer>
    </div>
  );
};

export default LandingPage;